import { render, staticRenderFns } from "./ClockServerFeature.vue?vue&type=template&id=f4714064&scoped=true&"
import script from "./ClockServerFeature.vue?vue&type=script&lang=js&"
export * from "./ClockServerFeature.vue?vue&type=script&lang=js&"
import style0 from "./ClockServerFeature.vue?vue&type=style&index=0&id=f4714064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4714064",
  null
  
)

export default component.exports